import WorkAssignmentContent from "./WorkAssignmentContent";

export default function WorkAssignmentActive() {
    const queryPredicates = (w => w.or(w => [
        w.pffsm__Assignment_Status__c.eq("New"),
        w.pffsm__Assignment_Status__c.eq("Schedule Confirmed")
    ]));

    return (<WorkAssignmentContent queryPredicates={ queryPredicates }/>);
}